// import { Rate, Card} from "antd";
import React from "react";

import FusionCharts from "fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import ReactFC from "react-fusioncharts"; //react-fusioncharts
import moment from "moment";

const dateFormate = date => {
  date = moment(date).format(" Do MMM");
  return date;
};

ReactFC.fcRoot(FusionCharts, Charts, FusionTheme);

const BarChartReports = propsInfo => {
  const { graphAnalytics } = propsInfo;
  const { connectedMembers, subscribedMembers, graphData } = graphAnalytics;
  const label =
    graphData &&
    graphData.length > 0 &&
    graphData.map(item => {
      return { label: dateFormate(item.label) };
    });
  const membersData =
    graphData &&
    graphData.length > 0 &&
    graphData.map(item => {
      return { value: item.totalMember };
    });

  const subscribeData =
    graphData &&
    graphData.length > 0 &&
    graphData.map(item => {
      return { value: item.totalSubscribe };
    });
  var dataSource = {
    chart: {
      // caption: "Revenues and Profits",
      // subCaption: "For last year",
      xAxisname: "Month",
      // pYAxisName: "Amount (In USD)",
      // sYAxisName: "Profit %",
      // numberPrefix: "$",
      // sNumberSuffix: "%",
      sYAxisMaxValue: "50",

      //Cosmetics
      divlineAlpha: "100",
      divlineColor: "#999999",
      divlineThickness: "1",
      divLineIsDashed: "1",
      divLineDashLen: "1",
      divLineGapLen: "1",
      usePlotGradientColor: "0",
      anchorRadius: "3",
      theme: "fusion",
      palettecolors: "e65255, 9bd2fc"
    },
    categories: [
      {
        category: label
        // category: [
        //   ({
        //     label: "Jan"
        //   },
        //   {
        //     label: "Feb"
        //   },
        //   {
        //     label: "Mar"
        //   },
        //   {
        //     label: "Apr"
        //   },
        //   {
        //     label: "May"
        //   },
        //   {
        //     label: "Jun"
        //   },
        //   {
        //     label: "Jul"
        //   },
        //   {
        //     label: "Aug"
        //   },
        //   {
        //     label: "Sep"
        //   },
        //   {
        //     label: "Oct"
        //   },
        //   {
        //     label: "Nov"
        //   },
        //   {
        //     label: "Dec"
        //   })
        // ]
      }
    ],
    dataset: [
      {
        seriesName: "Members",
        data: membersData
        // data: [
        //   {
        //     value: "160"
        //   },
        //   {
        //     value: "200"
        //   },
        //   {
        //     value: "180"
        //   },
        //   {
        //     value: "190"
        //   },
        //   {
        //     value: "150"
        //   },
        //   {
        //     value: "210"
        //   },
        //   {
        //     value: "160"
        //   },
        //   {
        //     value: "200"
        //   },
        //   {
        //     value: "170"
        //   },
        //   {
        //     value: "220"
        //   },
        //   {
        //     value: "190"
        //   },
        //   {
        //     value: "230"
        //   }
        // ]
      },
      {
        seriesName: "Subscribed",
        renderAs: "splinearea",
        showValues: "0",
        data: subscribeData
        // data: [
        //   {
        //     value: "40"
        //   },
        //   {
        //     value: "500"
        //   },
        //   {
        //     value: "300"
        //   },
        //   {
        //     value: "400"
        //   },
        //   {
        //     value: "100"
        //   },
        //   {
        //     value: "70"
        //   },
        //   {
        //     value: "100"
        //   },
        //   {
        //     value: "400"
        //   },
        //   {
        //     value: "100"
        //   },
        //   {
        //     value: "80"
        //   },
        //   {
        //     value: "200"
        //   },
        //   {
        //     value: "70"
        //   }
        // ]
      }
    ]
  };

  const chartConfigs = {
    type: "mscombidy2d",
    renderAt: "chart-container",
    width: "100%",
    height: 400,
    dataFormat: "json",
    dataSource: dataSource
  };
  return (
    <div>
      <ReactFC {...chartConfigs} />
      <div
        style={{
          position: "absolute",
          bottom: "0px",
          margin: "0px",
          width: "100%",
          backgroundColor: "#ffffff",
          padding: "10px 60px"
        }}
      ></div>
    </div>
  );
};

export default BarChartReports;
